import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import SocialLinkPage from './SocialLinkPage';
import {
    logInUser as logInUserAction,
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    clearAuthNotification as clearAuthNotificationAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
} from '../../actions/auth';

const _mapStateToProps = ({ authentication }) => ({
    authNotificationOptions: authentication.authNotificationOptions,
    disableRecaptcha3: authentication.disableRecaptcha3,
    email: authentication.email,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    socialAuthenticationData: authentication.socialAuthenticationData,
});

const _mapDispatchToProps = {
    onLogInUser: logInUserAction,
    moveBack: moveBackAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SocialLinkPage),
);
